var _style, _g, _g2, _g3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoliticalDebateBro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F1AB1E;}\n\t.st1{opacity:0.7;fill:#FFFFFF;enable-background:new    ;}\n\t.st2{fill:#263238;}\n\t.st3{fill:#CCCCCC;stroke:#263238;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#263238;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st5{fill:#FFFFFF;stroke:#263238;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st6{fill:#696969;stroke:#263238;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st7{fill:#F1AB1E;stroke:#263238;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st8{fill:#263238;stroke:#263238;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st9{fill:#B2B2B2;stroke:#263238;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st10{fill:none;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;}\n\t.st11{fill:#515B60;stroke:#263238;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st12{fill:#FFFFFF;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;}\n\t.st13{fill:#F1AB1E;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M437,132.5c-37.8-49.8-99.3-85.4-159.2-95.2C184,22,133,70,106,130s-84,69-86,139s43,91,94,110s66,48,127,61 s124.2-4.5,151-41s59-65,75-118C483.6,226,468.6,174.3,437,132.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M437,132.5c-37.8-49.8-99.3-85.4-159.2-95.2C184,22,133,70,106,130s-84,69-86,139s43,91,94,110s66,48,127,61 s124.2-4.5,151-41s59-65,75-118C483.6,226,468.6,174.3,437,132.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M29.4,328.4c2.3,1,7.8,0.9,7.8,0.9s-1.2-3.6-1.3-3.8c-1.2-2.5-5-6.7-8.2-6.3c-2,0.3-3.4,2.3-3.1,4.3 c0,0.1,0,0.2,0.1,0.4C25.2,325.9,27.5,327.5,29.4,328.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M101.8,309.5c-3.1-0.3-6.9,4-8,6.5c-0.1,0.2-1.2,3.9-1.2,3.9h0.1c-0.6,0.7-1.2,1.4-1.9,2.2 c-1.2,1.5-2.6,3.2-4,5.2c-1.5,2.1-2.9,4.3-4.1,6.5c-1.4,2.5-2.6,5.2-3.5,7.9c0,0,0,0.1,0,0.1c0-0.9,0-3.5,0-3.7 c-0.4-2.8-2.7-8-5.8-8.5c-2-0.3-3.9,1.1-4.3,3.1c0,0.1,0,0.3,0,0.4c-0.2,2.2,1.4,4.4,3,5.8c1.8,1.6,6.7,3.1,7.1,3.2 c-0.9,2.8-1.6,5.7-2.1,8.6c-0.3,1.7-0.6,3.4-0.8,5.1c0-0.8,0-1.5,0-1.6c-0.4-2.8-2.7-8-5.8-8.5c-2-0.3-3.9,1.1-4.3,3.1 c0,0.1,0,0.3,0,0.4c-0.2,2.2,1.4,4.4,3,5.8s5.8,2.8,6.9,3.2c-0.1,0.6-0.2,1.3-0.2,2c-0.4,3.2-0.7,6.3-1.2,9.4 c-0.2,1.1-0.3,2.1-0.5,3.2c0-0.7,0-1.3,0-1.4c-0.4-2.8-2.7-8-5.8-8.5c-2-0.3-3.9,1.1-4.3,3.1c0,0.1,0,0.3,0,0.4 c-0.2,2.2,1.4,4.4,3,5.8s5.3,2.7,6.7,3.1c-0.2,1.1-0.5,2.2-0.7,3.2c-0.2,0.7-0.3,1.4-0.6,2.1s-0.4,1.4-0.7,2.1 c-0.5,1.3-1,2.6-1.4,3.9c-0.3,0.9-0.7,1.7-1,2.5c0.2-1.1,0.5-3.2,0.5-3.4c-0.1-2.5-0.7-4.9-2-7c0-0.3,0-0.6,0-0.8 c-0.2-2-2-3.5-4.1-3.3c-0.2,0-0.4,0.1-0.6,0.1c-3,0.8-5,6.1-5.1,9c0,0.2,0.1,2,0.2,3.1c-0.2-0.7-0.3-1.3-0.5-2 c-0.3-1.4-0.7-2.7-1.1-4.1l-0.6-2.1c-0.2-0.7-0.5-1.4-0.7-2.1c-0.6-1.6-1.3-3.3-2-4.9c1.2-0.3,5.3-1.4,7-2.6s3.4-3.4,3.4-5.6 c0.1-2.1-1.6-3.8-3.6-3.8c-0.1,0-0.2,0-0.4,0c-3.1,0.3-5.8,5.3-6.4,8.1c0,0.2-0.2,2.2-0.3,3.3c-0.5-1-0.9-2-1.4-2.9 c-1.4-2.8-2.9-5.6-4.4-8.4c-0.5-0.9-0.9-1.7-1.3-2.6c0.4-0.1,5.4-1.2,7.3-2.7c1.7-1.3,3.4-3.4,3.4-5.6c0-2.1-1.6-3.8-3.6-3.8 c-0.1,0-0.2,0-0.4,0c-3.1,0.3-5.8,5.3-6.4,8.1c0,0.2-0.3,3.1-0.3,3.9c-1-1.9-2-3.8-2.8-5.7c-1.2-2.6-2.2-5.2-3.1-7.9 c0.2,0,5.4-1.2,7.3-2.7c1.7-1.3,3.4-3.4,3.4-5.6c0.1-2.1-1.6-3.8-3.6-3.8c-0.1,0-0.2,0-0.4,0c-3.1,0.3-5.8,5.3-6.4,8.1 c0,0.2-0.3,3.4-0.3,3.9c0-0.2-0.1-0.3-0.2-0.5c-0.8-2.7-1.3-5.5-1.6-8.4c-0.2-1.6-0.3-3.1-0.3-4.5c1-0.1,5.5-0.7,7.4-1.9 s3.8-3,4-5.2c0.3-2-1.2-3.9-3.2-4.2c-0.1,0-0.3,0-0.4,0c-3.2,0-6.4,4.6-7.3,7.3c0,0.1-0.4,1.7-0.6,2.8c0-0.7,0-1.4,0-2 c0-2.4,0.2-4.6,0.3-6.5c0.1-1.1,0.2-2.1,0.3-3c0.9-0.6,4.6-3.2,5.7-5s2-4.4,1.2-6.5c-0.7-1.9-2.8-2.9-4.8-2.3 c-0.1,0-0.3,0.1-0.4,0.2c-2.8,1.4-3.5,7.1-3.1,9.9c0,0.2,1.1,3.9,1.2,3.9h0c-0.1,0.9-0.2,1.9-0.3,2.9c-0.2,1.9-0.4,4.1-0.5,6.5 c-0.1,2.6,0,5.2,0.2,7.7c0.2,2.9,0.7,5.7,1.4,8.5v0.1c-0.5-0.8-2-2.9-2.1-3.1c-1.8-2.1-6.6-5.2-9.5-3.9c-1.9,0.9-2.7,3.1-1.8,4.9 c0.1,0.1,0.1,0.2,0.2,0.4c1.1,2,3.6,2.9,5.7,3.2c2.3,0.3,7.3-1.1,7.7-1.2c0.8,2.8,1.8,5.6,3,8.3c0.7,1.6,1.4,3.1,2.2,4.7 c-0.5-0.7-0.9-1.2-0.9-1.3c-1.8-2.1-6.7-5.2-9.5-3.9c-1.9,0.8-2.7,3-1.9,4.9c0,0.1,0.1,0.2,0.1,0.3c1.1,2,3.6,2.9,5.7,3.2 s6.3-0.8,7.5-1.1L46,360c1.4,2.9,2.9,5.7,4.2,8.5c0.5,1,0.9,2,1.3,3c-0.4-0.6-0.8-1.1-0.8-1.1c-1.8-2.1-6.6-5.2-9.5-3.9 c-1.9,0.9-2.7,3.1-1.8,5c0.1,0.1,0.1,0.2,0.2,0.3c1.1,2,3.6,2.9,5.7,3.2s5.9-0.7,7.3-1.1c0.4,1,0.8,2.1,1.2,3.1 c0.2,0.7,0.5,1.4,0.7,2.1s0.4,1.4,0.6,2.1c0.3,1.4,0.7,2.7,0.9,4.1c0.2,0.9,0.4,1.8,0.6,2.7c-0.5-1-1.4-2.9-1.5-3.1 c-1.5-2.4-5.8-6.1-8.8-5.3c-2,0.6-3.1,2.6-2.6,4.6c0,0.1,0.1,0.3,0.1,0.4c0.8,2.1,3.2,3.4,5.2,4c2.2,0.7,7.1,0.1,7.7,0 c0.3,1.5,0.6,2.9,0.8,4.2c0.8,4.7,1.3,8.6,1.7,11.4c0.1,0.5,0.1,0.9,0.2,1.3h-9.5l3.5,67.6h16.2l3.5-67.6H64l0.2-0.4 c1.2-2.5,2.9-6.2,4.7-10.6c0.6-1.4,1.2-2.9,1.8-4.5c0.6,0.1,5.4,1.1,7.7,0.6c2-0.5,4.5-1.6,5.4-3.6c0.9-1.8,0.2-4.1-1.7-5 c-0.1-0.1-0.2-0.1-0.4-0.2c-3-1-7.5,2.4-9.2,4.6c-0.1,0.1-1,1.7-1.6,2.7c0.2-0.6,0.5-1.2,0.7-1.9c0.5-1.3,0.9-2.6,1.4-4l0.6-2.1 c0.2-0.7,0.4-1.5,0.6-2.2c0.4-1.7,0.7-3.5,1-5.2c1.1,0.4,5.2,1.8,7.3,1.7s4.7-0.9,5.9-2.8c1.2-1.7,0.8-4-0.9-5.2 c-0.1-0.1-0.2-0.2-0.4-0.2c-2.8-1.5-7.8,1.2-9.8,3.2c-0.1,0.1-1.4,1.7-2.1,2.6c0.2-1.1,0.3-2.1,0.5-3.2c0.4-3.1,0.7-6.3,1-9.5 c0.1-1,0.2-1.9,0.3-2.9c0.4,0.1,5.2,1.9,7.6,1.8c2.1-0.1,4.7-0.9,5.9-2.8c1.2-1.7,0.8-4-0.9-5.2c-0.1-0.1-0.2-0.2-0.4-0.2 c-2.8-1.4-7.8,1.2-9.8,3.2c-0.2,0.1-2,2.4-2.4,3c0.2-2.1,0.5-4.2,0.8-6.3c0.4-2.8,1-5.6,1.8-8.3c0.2,0.1,5.2,2,7.6,1.8 c2.1-0.1,4.7-0.9,5.9-2.8c1.2-1.7,0.8-4-0.9-5.2c-0.1-0.1-0.2-0.1-0.3-0.2c-2.8-1.4-7.8,1.2-9.8,3.2c-0.2,0.1-2.1,2.6-2.4,3.1 c0-0.2,0.1-0.3,0.1-0.5c0.9-2.7,2-5.4,3.3-7.9c0.7-1.4,1.5-2.7,2.2-4c0.9,0.5,5,2.4,7.2,2.5s4.8-0.4,6.2-2.1 c1.4-1.5,1.2-3.9-0.3-5.3c-0.1-0.1-0.2-0.2-0.3-0.2c-2.6-1.7-7.9,0.4-10.1,2.1c-0.1,0.1-1.2,1.2-2,2c0.4-0.6,0.7-1.1,1.1-1.7 c1.3-2,2.7-3.7,3.8-5.2c0.7-0.9,1.3-1.6,1.9-2.3c1.1,0,5.6-0.2,7.5-1.1s4.1-2.6,4.5-4.7c0.5-2-0.8-4-2.8-4.5 C102.1,309.6,102,309.5,101.8,309.5z M67.2,393.7c-1.9,4.4-3.6,7.9-4.9,10.4c-0.2,0.5-0.5,0.9-0.7,1.3h-0.2c-0.1-0.5-0.1-1-0.2-1.6 c-0.4-2.8-1-6.7-1.9-11.4c-0.3-1.5-0.6-3.1-1-4.7c1.5-0.6,2.9-1.2,4.3-2c1.6,1.7,5.8,3.8,6.3,4C68.3,391.1,67.7,392.5,67.2,393.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M85.3,329.6c0,0,1-3.7,1-3.9c0.4-2.8-0.5-8.4-3.3-9.8c-1.9-0.8-4.1,0.1-4.9,1.9c0,0.1-0.1,0.2-0.1,0.3 c-0.8,2.1,0.2,4.7,1.3,6.4C80.7,326.6,85.3,329.6,85.3,329.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M403.5,328.4c2.3,1,7.8,0.9,7.8,0.9s-1.2-3.6-1.3-3.8c-1.2-2.5-5-6.7-8.2-6.3c-2,0.3-3.4,2.2-3.1,4.3 c0,0.1,0,0.3,0.1,0.4C399.3,325.9,401.5,327.5,403.5,328.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M475.9,309.5c-3.1-0.3-6.9,4-8,6.5c-0.1,0.2-1.2,3.9-1.2,3.9h0.1c-0.6,0.7-1.2,1.4-1.9,2.2 c-1.2,1.5-2.6,3.2-4,5.2c-1.5,2.1-2.9,4.3-4.1,6.5c-1.4,2.5-2.6,5.2-3.5,7.9c0,0,0,0.1,0,0.1c0-0.9,0-3.5,0-3.7 c-0.4-2.8-2.7-8-5.8-8.5c-2-0.3-3.9,1.1-4.3,3.1c0,0.1,0,0.3,0,0.4c-0.2,2.2,1.4,4.4,3,5.8c1.8,1.6,6.7,3.1,7.1,3.2 c-0.9,2.8-1.6,5.7-2.1,8.6c-0.3,1.7-0.5,3.4-0.8,5.1c0-0.8,0-1.5,0-1.6c-0.4-2.8-2.7-8-5.8-8.5c-2-0.3-3.9,1.1-4.3,3.1 c0,0.1,0,0.3,0,0.4c-0.2,2.2,1.4,4.4,3,5.8s5.8,2.8,6.9,3.2c-0.1,0.6-0.2,1.3-0.2,2c-0.4,3.2-0.8,6.3-1.2,9.4 c-0.2,1.1-0.4,2.1-0.5,3.2c0-0.7,0-1.3,0-1.4c-0.4-2.8-2.7-8-5.8-8.5c-2-0.3-3.9,1.1-4.3,3.1c0,0.1,0,0.3,0,0.4 c-0.2,2.2,1.4,4.4,3,5.8s5.3,2.7,6.7,3.1c-0.2,1.1-0.5,2.2-0.7,3.2c-0.2,0.7-0.4,1.4-0.6,2.1s-0.5,1.4-0.7,2.1 c-0.5,1.3-1,2.6-1.5,3.9c-0.3,0.9-0.7,1.7-1,2.5c0.2-1.1,0.5-3.2,0.5-3.4c0-2.5-0.7-4.9-1.9-7c0-0.3,0-0.6,0-0.8 c-0.3-2-2.1-3.5-4.2-3.2c-0.1,0-0.3,0-0.4,0.1c-3,0.8-5,6.1-5.1,9c0,0.2,0.1,2,0.2,3.1c-0.2-0.7-0.3-1.3-0.5-2 c-0.3-1.4-0.7-2.7-1.1-4.1l-0.6-2.1c-0.2-0.7-0.5-1.4-0.7-2.1c-0.6-1.6-1.3-3.3-2-4.9c1.2-0.3,5.4-1.4,7-2.6s3.4-3.4,3.4-5.6 c0.1-2.1-1.6-3.8-3.6-3.8c-0.1,0-0.2,0-0.4,0c-3.1,0.3-5.9,5.3-6.4,8.1c0,0.2-0.2,2.2-0.3,3.3c-0.4-1-0.9-2-1.4-2.9 c-1.4-2.8-2.9-5.6-4.4-8.4l-1.5-2.6c0.4-0.1,5.4-1.2,7.3-2.7c1.7-1.3,3.4-3.4,3.4-5.6c0-2.1-1.6-3.8-3.6-3.8c-0.1,0-0.2,0-0.4,0 c-3.1,0.3-5.9,5.3-6.4,8.1c0,0.2-0.3,3.1-0.3,3.9c-1-1.9-2-3.8-2.8-5.7c-1.2-2.6-2.2-5.2-3.1-7.9c0.2,0,5.4-1.2,7.3-2.7 c1.7-1.3,3.4-3.4,3.4-5.6c0.1-2.1-1.6-3.8-3.6-3.8c-0.1,0-0.3,0-0.4,0c-3.1,0.3-5.9,5.3-6.4,8.1c0,0.2-0.3,3.4-0.3,3.9 c0-0.2-0.1-0.3-0.2-0.5c-0.8-2.7-1.3-5.5-1.6-8.4c-0.2-1.6-0.2-3.1-0.3-4.5c1-0.1,5.5-0.7,7.4-1.9s3.8-3,4-5.2 c0.3-2-1.2-3.9-3.2-4.2c-0.1,0-0.3,0-0.4,0c-3.1,0-6.4,4.6-7.3,7.3c0,0.1-0.4,1.7-0.6,2.8c0-0.7,0-1.4,0-2c0-2.4,0.2-4.6,0.3-6.5 c0.1-1.1,0.2-2.1,0.3-3c0.9-0.6,4.5-3.2,5.7-5s2-4.4,1.2-6.5c-0.7-1.9-2.8-2.9-4.8-2.3c-0.1,0-0.3,0.1-0.4,0.2 c-2.8,1.4-3.5,7.1-3.1,9.9c0,0.2,1.1,3.9,1.1,3.9h0c-0.1,0.9-0.2,1.9-0.4,2.9c-0.2,1.9-0.4,4.1-0.5,6.5c-0.1,2.6,0,5.2,0.2,7.7 c0.2,2.9,0.7,5.7,1.4,8.5v0.1c-0.5-0.8-2-2.9-2.1-3.1c-1.8-2.1-6.6-5.2-9.5-3.9c-1.9,0.9-2.7,3.1-1.8,4.9c0.1,0.1,0.1,0.2,0.2,0.4 c1.1,2,3.6,2.9,5.7,3.2c2.4,0.3,7.3-1.1,7.7-1.2c0.8,2.8,1.8,5.6,3,8.3c0.7,1.6,1.4,3.1,2.2,4.7c-0.5-0.7-0.9-1.2-0.9-1.3 c-1.9-2.1-6.6-5.2-9.5-3.9c-1.9,0.9-2.7,3.1-1.8,4.9c0.1,0.1,0.1,0.2,0.2,0.4c1.1,2,3.6,2.9,5.7,3.2s6.3-0.8,7.5-1.1 c0.3,0.6,0.6,1.2,0.9,1.8c1.4,2.9,2.9,5.7,4.2,8.5c0.5,1,0.9,2,1.3,3c-0.4-0.6-0.8-1.1-0.8-1.1c-1.8-2.1-6.6-5.2-9.5-3.9 c-1.9,0.9-2.7,3.1-1.8,4.9c0.1,0.1,0.1,0.2,0.2,0.4c1.1,2,3.6,2.9,5.7,3.2s5.9-0.7,7.2-1.1c0.4,1,0.8,2.1,1.2,3.1 c0.2,0.7,0.5,1.4,0.7,2.1s0.4,1.4,0.6,2.1c0.3,1.4,0.7,2.7,1,4.1c0.2,0.9,0.4,1.8,0.6,2.7c-0.5-1-1.4-2.9-1.5-3.1 c-1.5-2.4-5.8-6.1-8.8-5.3c-2,0.6-3.1,2.6-2.6,4.6c0,0.1,0.1,0.3,0.1,0.4c0.8,2.1,3.1,3.4,5.2,4c2.2,0.7,7.1,0.1,7.7,0 c0.3,1.5,0.6,2.9,0.8,4.2c0.8,4.7,1.3,8.6,1.6,11.4c0,0.5,0.1,0.9,0.1,1.3h-9.5l3.4,67.5h16.2l3.5-67.6H438l0.2-0.4 c1.2-2.5,2.9-6.2,4.7-10.6c0.6-1.4,1.2-2.9,1.8-4.5c0.6,0.1,5.5,1.1,7.7,0.6c2-0.5,4.5-1.6,5.5-3.6c0.9-1.8,0.2-4.1-1.7-5 c-0.1-0.1-0.2-0.1-0.4-0.2c-3-1-7.5,2.4-9.2,4.6c-0.1,0.1-1,1.7-1.6,2.7c0.2-0.6,0.5-1.2,0.7-1.9c0.5-1.3,0.9-2.6,1.4-4 c0.2-0.7,0.4-1.4,0.6-2.1s0.4-1.5,0.6-2.2c0.4-1.7,0.7-3.5,1-5.2c1.1,0.4,5.2,1.8,7.3,1.7s4.7-0.9,5.9-2.8c1.2-1.7,0.8-4-0.9-5.2 c-0.1-0.1-0.2-0.1-0.3-0.2c-2.8-1.5-7.8,1.2-9.8,3.2c-0.1,0.1-1.4,1.7-2.1,2.6c0.2-1.1,0.3-2.1,0.5-3.2c0.4-3.1,0.7-6.3,1-9.5 c0.1-1,0.2-1.9,0.3-2.9c0.4,0.1,5.2,1.9,7.5,1.8c2.1-0.1,4.7-0.9,5.9-2.8c1.2-1.7,0.8-4-0.9-5.2c-0.1-0.1-0.2-0.1-0.3-0.2 c-2.8-1.4-7.8,1.2-9.8,3.2c-0.1,0.1-2,2.4-2.4,3c0.2-2.1,0.5-4.2,0.8-6.3c0.4-2.8,1-5.6,1.8-8.3c0.2,0.1,5.2,2,7.6,1.8 c2.1-0.1,4.7-0.9,5.9-2.8c1.2-1.7,0.8-4-0.9-5.2c-0.1-0.1-0.2-0.1-0.3-0.2c-2.8-1.4-7.8,1.2-9.8,3.2c-0.2,0.1-2.1,2.6-2.5,3.1 c0-0.2,0.1-0.3,0.1-0.5c0.9-2.7,2-5.4,3.3-7.9c0.7-1.4,1.5-2.7,2.2-4c0.9,0.5,5,2.4,7.2,2.5s4.8-0.4,6.2-2.1 c1.4-1.5,1.2-3.9-0.3-5.3c-0.1-0.1-0.2-0.2-0.3-0.3c-2.6-1.7-7.9,0.4-10.1,2.1c-0.1,0.1-1.2,1.2-2,2c0.4-0.6,0.7-1.1,1.1-1.7 c1.3-2,2.6-3.7,3.8-5.2c0.7-0.9,1.3-1.6,1.9-2.3c1.1,0,5.6-0.2,7.5-1.1s4.1-2.6,4.5-4.7c0.5-2-0.8-4-2.8-4.5 C476.1,309.6,476,309.5,475.9,309.5z M441.2,393.7c-1.9,4.4-3.6,7.9-4.9,10.4c-0.2,0.5-0.5,0.9-0.7,1.3h-0.2 c-0.1-0.5-0.1-1-0.2-1.6c-0.4-2.8-1-6.7-1.9-11.4c-0.3-1.5-0.6-3.1-1-4.7c1.5-0.6,2.9-1.2,4.3-2c1.6,1.7,5.8,3.8,6.3,4 C442.3,391.1,441.8,392.5,441.2,393.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M459.4,329.6c0,0,1-3.7,1-3.9c0.4-2.8-0.5-8.4-3.3-9.8c-1.9-0.8-4.1,0-4.9,1.9c-0.1,0.1-0.1,0.3-0.1,0.4 c-0.8,2.1,0.2,4.7,1.3,6.4C454.7,326.6,459.4,329.6,459.4,329.6z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M278.1,168.2l-3.1-5.5c0,0-2.6-6.5-3.9-8.2s-4.1-2.6-6.7-2.7c-1.8-0.2-3.6-0.8-5.1-1.7c-1-0.5-2.9-0.9-2.9,0.7 s0.3,4.4,2.4,5c1.8,0.5,3.5,1.1,5.1,1.9c0,0-7.2,1.5-8.9,1.9s-8.7,1.2-9.6,1.9s0,2.6,0,2.6s-1.9,1.2,0.2,2.8s10.3,4.3,10.3,4.3 s-0.4,0.2,3.6,2.4s13.2,4.3,13.2,4.3L278.1,168.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M260.4,175c0,0-5-3.9-5.6-5.8s-2.2-8.7-0.3-9.1c1.9-0.3,3.8,5.3,3.4,6s1.7,3.4,1.9,3.9 c0.4,0.6,0.9,1.2,1.5,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M271.1,169.9c0,0-2.6-0.3-3.4-0.3c-1.7,0.3-3.4,0.7-5,1.2c0,0-0.9-8.7-2.9-8.9s-2.6,2.2-1.9,4.3 s0.9,8.9,2.2,9.6s11,1.7,11,1.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 245.4,
    y1: 163.9,
    x2: 253.1,
    y2: 164.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "281.7,169.5 277.3,166.2 270.1,180 277.6,184.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M357.1,129.8l-32.9,10.5l-20.2,47.2l-23.5-18.8l-7.5,19.6c0,0,41.4,30.4,43.1,30.4s10.2-10.2,10.2-10.2 l0.5,7.2l-5,16.9h67.1l3.6-29.3l2.8-9.4l3.9,20.4c0,0,6.9,4.1,13.3,3s10.5-12.7,10.5-12.7l-13.3-55.2c0,0-2.5-3-3.6-3.6 s-29.8-16-29.8-16L357.1,129.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M345.9,133.9l-9.4,17.7l7.7,5.5c0,0-6.1,2.2-7.2,2.8s0.8,16,3.6,23.2c2.3,5.5,5,10.9,8,16l-3.6,4.2l1.9,28.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M348.9,200.7c0,0,17.1-9.7,22.6-18.2s8.8-19.9,8.8-19.9l-5.5-3.3l8.3-3c0,0-1.7-13.5-1.7-19.9 c0-1.5,0-2.6-0.1-3.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M353.8,127.5c0,0-4.4,13.8-4.4,20.5s1.9,45.9,1.9,45.9s16.6-33.4,19.3-39c2.4-4.8,4.1-9.9,5-15.2 c0.6-4.9,1-9.7,1.1-14.6c-4.1,1.2-8.2,2.2-12.4,2.8C360.8,128.1,357.3,128,353.8,127.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M362.4,136.6l-7.7,7.5l1.9,9.7l-6.2,19.5c0.5,10.7,1,20.5,1,20.5l11.8-23.8l-3.3-16.5l7.5-8.3L362.4,136.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M353.8,127.5c0,0-4.4,13.8-4.4,20.5c0,0.2,0,0.6,0,0.9l10.8-6.4l1.7,0.6l9.5,10.4c2-4.4,3.5-9,4.3-13.8 c0.6-4.9,1-9.7,1.1-14.6c-4.1,1.2-8.2,2.2-12.4,2.8C360.8,128.1,357.3,128,353.8,127.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M376.5,129.8c0.1-2.7,0.2-4.7,0.2-4.7c-4.1,1.2-8.2,2.2-12.4,2.8c-3.5,0.3-7,0.2-10.5-0.3 c0,0,4.4,14.4,6.4,14.9C362,143,371.2,138.1,376.5,129.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M353.4,78.1c0,0-2.7-0.7-4.4,3.9s-0.5,20.6-0.5,20.6s-1.2-4.1-3.1-0.2s0.7,9.5,1.5,10.2c0.5,0.5,1.1,1,1.7,1.4 h1c0,0,0,9.2,1.5,11.2s5.3,8.5,7.3,8.7s7,0.2,7.8,0.2s10.2-6.3,11.9-8.7s3.2-8.2,3.2-8.2s6.5-3.4,7-8s-2.7-6.8-3.4-6.8 c-0.5,0-1,0.1-1.5,0.2c0,0,3.4-12.4,1.9-18.9s-18-9.7-23.5-9.2C358.5,74.6,355.6,75.9,353.4,78.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M347.1,100.8l1.4,1.9C348.5,102.7,348,100.9,347.1,100.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M384.1,102.4c-0.3,0-0.6,0.1-0.9,0.2c0,0,3.4-12.4,1.9-18.9s-13.5-12.2-22-10.3c-3.5,0.9-6.9,2.5-9.8,4.7 c0,0-2.7-0.7-4.4,3.9s-0.5,20.6-0.5,20.6l0.2-7.8c0,0,1-5.6,2.2-8s5.3-5.1,5.3-5.1c2.5,1.2,5.1,2.2,7.8,2.9 c3.4,0.7,10.7-1.7,10.7-1.7s2.4,1.5,2.7,3.6s-1.2,5.6-1,8s4.1,5.8,4.1,5.8s-1.7,5.1,0.7,5.1C382.2,105.6,383.2,104.2,384.1,102.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M359,107c0,0-3.9,8.5-2.4,9.5s5.6,1.2,7.3,1c0.9-0.1,1.7-0.4,2.4-1l3.4,5.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M355.3,115.8c-0.7,1.3-1.2,2.7-1.2,4.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M356.5,123.3c0,0,9-0.2,9.7,0.7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 369,
    cy: 105.6,
    rx: 1.1,
    ry: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M356.3,103.8c0,1-0.5,1.8-1.1,1.8s-1.1-0.8-1.1-1.8s0.5-1.8,1.1-1.8S356.3,102.8,356.3,103.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M363.7,101.2c3.1-0.6,6.3-0.8,9.4-0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M358,101c-1.9-1.1-4-1.7-6.2-1.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "382.3,173.1 392.8,173.7 390,170.6  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 395.5,
    y1: 193.8,
    x2: 399.4,
    y2: 162.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M393.3,221.4l-3.3,3.9l11,6.4l4.7-5.2C405.7,226.4,396.6,220.9,393.3,221.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M416.2,207.9c0,0-10-0.6-11.6,0s-11.3,13.5-11.3,13.5s2.5-0.6,7.5,2.8s7.7,5.2,7.7,5.2s14.1-8.6,16.3-11.3 s1.9-8.3,0-12.2s-2.5-4.7-2.5-4.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M400.5,230.1c0,0-9.3-6.1-11.1-6.9s-3.2-0.9-4.4-0.4s-6.9,9-6.9,9h24L400.5,230.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M382.5,232c0,0,5-6.6,6.1-7.5s1.9-0.7,1.9-0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M388.8,231.6c0,0,3-5.8,4.8-5.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 393.6,
    y1: 231.8,
    x2: 396.6,
    y2: 227.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M326.5,208.5c0,0-5.2-39.8,0.3-55.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "403.9,473.7 306.3,473.7 294.1,229 416.1,229  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "412.1,308 415.5,240 294.6,240 298,308  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M363.5,219c0-0.7-0.4-1.4-1-1.7c-0.2-10-0.9-19.9-1.5-26.2c1.2-0.5,1.9-1.7,1.8-3c-0.3-3.2-0.5-5.1-0.5-5.1 c-0.2-1.7-1.7-2.9-3.3-2.7c-1.7,0.2-2.9,1.7-2.7,3.3c0,0,0.2,1.9,0.5,5c0.1,1.3,1,2.3,2.2,2.6c0.5,6.3,1.2,16.2,1.5,26.1 c-0.6,0.4-1,1-1,1.7c0.1,6.4,0,12-0.4,16.6c-0.1,1.1,0.7,2.1,1.8,2.1c0,0,0,0,0,0h0.1c1,0,1.9-0.8,2-1.9 C363.5,231.2,363.6,225.5,363.5,219z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.1,
    y: 229,
    className: "st5",
    width: 146,
    height: 69.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.6,
    y: 229,
    className: "st2",
    width: 146,
    height: 18.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.8,
    y: 229,
    className: "st5",
    width: 152.7,
    height: 11.3
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M119.8,133.8c-3.4,2.8-7.1,5.3-11,7.5c-6.2,3.5-20.5,10-21,12.8s-6.8,63.4-6.5,64.4s12,1.8,13,1.8 s6.3-27.7,6.3-27.7s5,11.2,5.2,12s-5,26.9-5,26.9h61.8l0.5-29.9l1.2-3.2l1.2,19.7l16-2c0,0-5-43.7-5-46.9s0.5-18.2-0.5-19.8 S144.3,137,144.3,137l-6.8-5.7l-18.2,0.2L119.8,133.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M144.3,137l-6.8-5.7l-18.2,0.2l0.5,2.2c-3.4,2.8-7.1,5.3-11,7.5c-1.6,0.9-3.7,2-6,3.1 c1.8,2.4,9.3,10.7,27.5,13.6c13.2-1.2,22.9-12.5,26.1-16.7C149.9,139,144.3,137,144.3,137z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 113.1,
    y1: 145.5,
    x2: 129.6,
    y2: 148.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 137.1,
    y1: 147,
    x2: 148.6,
    y2: 144.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 151,
    y1: 201.9,
    x2: 155.6,
    y2: 201
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 117.1,
    y1: 209,
    x2: 145.9,
    y2: 203
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M164.3,198.3c1.2-2.9,1.8-6.1,1.8-9.2c0-5.5-0.8-17.2-0.8-17.2l1.8-6.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M94.8,174.3l4.8,3.7c0,0-0.5,11.5,1,14.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M180.3,214.5c0,0-6.5-1-11,0.8s-13.5,14-13.5,14h11.8c0,0,13.5-4,14.8-8S180.3,214.5,180.3,214.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M83.6,214.5c0,0,6.5-1,11,0.8s13.5,14,13.5,14H96.3c0,0-13.5-4-14.8-8S83.6,214.5,83.6,214.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M155.3,103.7c0,2.1-0.1,4.1-0.3,6.1c-0.3,2.3,1.8,6.9,2.9,8.9s-2.6,3.6-2.6,3.6l-0.6,0.6c0,0-0.4,1.5-0.9,3.2 c-0.1,0.4-4.4,0.1-4.4,0.1c1.3,0.8,2.5,1.6,3.6,2.5c-0.6,2-0.9,3.1-0.9,3.6c-0.2,1.1-3.7,1.9-5.2,1.8s-11.2-1.1-11.2-1.1l0.7,3.1 l-5-3.8c0,0-4.7-23.6-3.6-25.5c1.1-1.9,9-7.9,9.9-8.1s8.8-1.7,9.7-1.7s3.2,0.3,3.2,0.3S155.3,100.3,155.3,103.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M151.8,109.1c-0.9-1.1-2.3-1.6-3.7-1.3c-0.6,0.1-1.3,0.4-1.8,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M151.2,112.3c0,1-0.5,1.7-1,1.7s-1-0.8-1-1.7s0.5-1.7,1-1.7S151.2,111.3,151.2,112.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M154.2,126c-1.6,0.4-3.3,0.4-4.9,0.1c1.4,0.8,2.7,1.7,4,2.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M155.3,122.2c0,0-4.8,0.8-4.6-1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 147.9,
    y1: 111.3,
    x2: 151.3,
    y2: 110.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M134.6,106.1c0,0,0.8,23.2,1.3,25.6s3.5,6.9,3.5,6.9s-11.5-1.3-19.2-1.6c-5.2-0.3-10.4-1.2-15.5-2.7 c0,0,0.8-17,1.1-27.8c0.4-18.8,10.7-22.9,15.8-25.3s14.9-1.9,21.6-0.6s14.1,14.9,15.2,18.4c0.6,1.6,0.9,3.3,1.1,5.1L134.6,106.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 109.5,
    y1: 120.5,
    x2: 109.7,
    y2: 117.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 108.6,
    y1: 135.5,
    x2: 109.2,
    y2: 124.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 118.6,
    y1: 136.3,
    x2: 119,
    y2: 129.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 133.2,
    y1: 137.8,
    x2: 129.8,
    y2: 131.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M122.6,83.9c0,0-7.1,2.3-8.9,9.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M124.4,111.4v4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M126.7,90.8c0,0-2.3,2.5-2.3,10.1v6.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 134.6,
    y1: 106.1,
    x2: 136.1,
    y2: 96.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 144.2,
    y1: 105.3,
    x2: 143.1,
    y2: 100.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 154.7,
    y1: 104.5,
    x2: 153.4,
    y2: 101.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "182.5,473.7 84.9,473.7 72.7,229 194.7,229  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "190.8,308 194.2,240 73.3,240 76.7,308  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M139.9,219c0-0.7-0.4-1.4-1-1.7c-0.2-10-0.9-19.9-1.5-26.2c1.2-0.5,1.9-1.7,1.7-3c-0.3-3.2-0.5-5.1-0.5-5.1 c-0.2-1.7-1.7-2.9-3.3-2.7s-2.9,1.7-2.7,3.3c0,0,0.2,1.9,0.5,5c0.1,1.3,1,2.3,2.2,2.6c0.5,6.3,1.2,16.2,1.5,26.1 c-0.6,0.4-1,1-1,1.7c0.1,6.4,0,12-0.4,16.6c-0.1,1.1,0.7,2.1,1.8,2.1c0,0,0,0,0,0h0.2c1,0,1.9-0.8,2-1.9 C139.9,231.2,140.1,225.5,139.9,219z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.7,
    y: 229,
    className: "st5",
    width: 146,
    height: 69.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.7,
    y: 229,
    className: "st2",
    width: 146,
    height: 18.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.4,
    y: 229,
    className: "st5",
    width: 152.7,
    height: 11.3
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M192.5,126.9l5.5-13.3c-1.9-2.4-3-5.4-3-8.6V78.8c0-7.6,6.1-13.7,13.7-13.7h53.7c7.6,0,13.7,6.1,13.7,13.7v0 V105c0,7.6-6.1,13.7-13.7,13.7l0,0h-53.7c-0.6,0-1.1,0-1.7-0.1L192.5,126.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 252.1,
    cy: 91.9,
    r: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M232.1,91.9c0-2,1.6-3.5,3.6-3.5s3.6,1.6,3.6,3.6c0,2-1.6,3.5-3.6,3.5C233.7,95.5,232.1,93.9,232.1,91.9 L232.1,91.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 219.2,
    cy: 91.9,
    r: 3.6
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 20,
    y1: 473.7,
    x2: 483,
    y2: 473.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoliticalDebateBro);
export default __webpack_public_path__ + "static/media/Political-debate-bro.c68e17a0deabba6b4803e13fcd21f3e6.svg";
export { ForwardRef as ReactComponent };